import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseLanguage: 'Choose language',
});
